import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";

export const useMsbTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            //rules: [],
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const hardReloadSelection = (props = {}) => {
        setConfig({
            ...config,
            rules: [],
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onRuleClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('name')
        })
    }

    const onModifiedClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('baseRule')
        })
    }

    const onSectionClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('sectionName')
        })
    }

    const onSubsectionClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('subsectionName')
        })
    }

    const onModifiedOnClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('updatedOn')
        })
    }

    const onCreatedOnClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('createdOn')
        })
    }

    const onUserClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('user')
        })
    }

    const onSeverityClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('severity')
        })
    }

    const changeRuleCategory = (id) => {
        if (Number(id) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('categoryId')
            })
        } else {
            history.push({
                pathname: history.pathname,
                search: urlService.replaceFilters('categoryId', id)
            })
        }
    }

    const updatePagination = (page, size) => {
        history.push(
            {
                pathname: history.pathname,
                search: urlService.updatePagination(page, size)
            }
        )
    }

    return {
        hardReload,
        hardReloadSelection,
        onRuleClick,
        onSectionClick,
        onSubsectionClick,
        onModifiedClick,
        onModifiedOnClick,
        onCreatedOnClick,
        onUserClick,
        onSeverityClick,
        changeRuleCategory,
        updatePagination
    }
}
